export default {
  name: 'CoreNiotixLogo',
  props: {
    color: {
      type: String,
      required: true,
      default: '#000'
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    colorShades() {
      return [this.adjustColor(this.color, this.dark ? 0.75 : 0.25, this.dark), this.adjustColor(this.color, 0.5, this.dark)];
    },
    height() {
      return this.$attrs.height || undefined;
    },
    width() {
      return this.$attrs.width || undefined;
    }
  },
  methods: {
    adjustColor(hexColor, alpha, dark = false) {
      let hex = hexColor.replace('#', '');

      // remove potential alpha from hex code
      if (hex.length !== 6) {
        hex = hex.substring(0, 3);
      }

      // extend possible 3 character hex to 6 characters
      if (hex.length === 3) {
        hex = hex.replace(/([^#])/g, '$1$1');
      }
      const background = dark ? 0 : 255;
      const [r, g, b] = hex.match(/.{1,2}/g).map(color => Math.floor(parseInt(color, 16) * alpha + background * (1 - alpha)).toString(16).padStart(2, '0'));
      return `#${[r, g, b].join('')}`;
    }
  }
};